'use strict'

module.exports = paragraph

var all = require('../all')

/* Transform a paragraph. */
function paragraph(h, node) {
  return h(node, 'p', all(h, node))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/paragraph.js
// module id = 901
// module chunks = 95715928098905 168707334958949